// The one frame gateway nodes send each other (spec/09 §8, §9; INFRA-18, #379).
//
// `4409` means "replaced by a newer connection for the same station". When a station reconnects it
// may land on a different node from the socket it left behind — a half-open TCP connection the old
// node has not noticed yet. The new node publishes this on `station:{id}`; the node holding an older
// socket for that station closes it with `4409`, and every node that holds the newer one ignores it.
//
// It travels on the station's own channel because that is the one channel every node holding the
// station already listens to, and it never reaches a client: the gateway consumes it before
// delivery. It is here, in the contract, so that it is a validated envelope like every other frame
// on Valkey rather than a private format one node could spell differently from the next.
import { z } from "../zod.js";
import { realtimeMessage } from "./envelope.js";
export const GATEWAY_CONNECTION_REPLACED = 'gateway.connection.replaced';
export const GatewayConnectionReplacedPayloadSchema = z
    .object({
    /** The node that holds the new socket. */
    nodeId: z.string().min(1).max(128),
    /** The new socket's id on that node. Every other socket for the station is the older one. */
    connectionId: z.string().min(1).max(128),
})
    .openapi('GatewayConnectionReplacedPayload', {
    description: 'Gateway to gateway: a newer socket for this station exists; close the older one with 4409.',
});
export const GatewayConnectionReplacedMessage = realtimeMessage('evt', GATEWAY_CONNECTION_REPLACED, GatewayConnectionReplacedPayloadSchema);
//# sourceMappingURL=gateway.js.map